import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./login";
import HomePage from "./home";

export default function App() {
  const [authenticated, setAuthenticated] = useState(null); // null = loading

  // Check authentication on app load
  useEffect(() => {
    fetch("/api/auth/check", {
      credentials: "include",
    })
      .then((res) => {
        if (res.ok) setAuthenticated(true);
        else setAuthenticated(false);
      })
      .catch(() => setAuthenticated(false));
  }, []);

  if (authenticated === null) return <div>Loading...</div>; // optional spinner

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            authenticated ? <Navigate to="/home" /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/login"
          element={
            authenticated ? <Navigate to="/home" /> : <Login setAuthenticated={setAuthenticated} />
          }
        />
        <Route
          path="/home/*"
          element={
            authenticated ? <HomePage setAuthenticated={setAuthenticated} /> : <Navigate to="/login" />
          }
        />
      </Routes>
    </Router>
  );
}